const { innerWidth: width } = window;

export const customStyles = {
    content: {
        width: width < 768 ? '90%' : '390px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    }
}

export const customStyles2 = {
    content: {
        width: width < 768 ? '90%' : '767px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    }
}
